import { createReducer, on } from '@ngrx/store';
import { LookBook, LookBookItem } from '@epicuro-next/models/engagement';

import {
  createLookBook,
  createLookBookError,
  createLookBookSuccess,
} from '../create/create-shop-the-look.actions';
import { reorderSelectedLists, sortLookBookItems } from '../utils';

import {
  clearShopTheLookEditState,
  deleteLookBookError,
  editLookBook,
  editLookBookError,
  editLookBookSuccess,
  loadLookBookEdit,
  loadLookBookEditError,
  loadLookBookEditSuccess,
  removeFromSelectedLists,
  reorderShopTheLookSelectedItems,
  setListToSelected,
  setSelectedLists,
} from './edit-shop-the-look-actions';

export interface EditShopTheLooksState {
  lookBook?: LookBook;
  selectedLookBookItems: LookBookItem[];
  lookBookLoading: boolean;
  lookBookError?: string;
}

export const initial: EditShopTheLooksState = {
  lookBookLoading: false,
  selectedLookBookItems: [],
};

export const editShopTheLookReducer = createReducer<EditShopTheLooksState>(
  initial,
  on(setListToSelected, (state, { lookBookItem }) => ({
    ...state,
    selectedLookBookItems: state.selectedLookBookItems?.concat(lookBookItem),
  })),
  on(setSelectedLists, (state, { lists }) => {
    return {
      ...state,
      selectedLookBookItems: lists,
      loading: false,
    };
  }),
  on(removeFromSelectedLists, (state, { productListId }) => {
    return {
      ...state,
      selectedLookBookItems: state.selectedLookBookItems?.filter(
        (list) => list.productListId !== productListId,
      ),
    };
  }),
  on(loadLookBookEdit, (state, { lookBookId }) => ({
    ...state,
    lookBook: undefined,
    lookBookLoading: !!lookBookId,
    selectedLookBookItems: [],
    lookBookError: undefined,
  })),
  on(loadLookBookEditSuccess, (state, { lookBook }) => ({
    ...state,
    lookBook,
    selectedLookBookItems: sortLookBookItems(lookBook.items),
    lookBookLoading: false,
  })),
  on(loadLookBookEditError, (state, { error }) => ({
    ...state,
    lookBook: undefined,
    lookBookError: error,
    lookBookLoading: false,
  })),
  on(reorderShopTheLookSelectedItems, (state, { prevIndex, currentIndex }) => ({
    ...state,
    selectedLookBookItems: reorderSelectedLists(
      state.selectedLookBookItems,
      prevIndex,
      currentIndex,
    ),
  })),
  on(createLookBook, (state) => ({
    ...state,
    lookBookLoading: true,
  })),
  on(editLookBook, (state) => ({
    ...state,
    lookBookLoading: true,
  })),
  on(createLookBookSuccess, (state) => ({
    ...state,
    lookBookLoading: false,
  })),
  on(editLookBookSuccess, (state) => ({
    ...state,
    lookBookLoading: false,
  })),
  on(editLookBookError, (state, { error }) => ({
    ...state,
    lookBook: undefined,
    lookBookError: error,
    lookBookLoading: false,
  })),
  on(createLookBookError, (state, { error }) => ({
    ...state,
    lookBook: undefined,
    lookBookLoading: false,
    lookBookError: error,
  })),
  on(deleteLookBookError, (state, { error }) => ({
    ...state,
    lookBook: undefined,
    lookBookLoading: false,
    lookBookError: error,
  })),
  on(clearShopTheLookEditState, () => ({
    ...initial,
  })),
);
